export const BORDER_WIDTH_MIN = 1;
export const BORDER_WIDTH_MAX = 10;

// The page part of a router URL, without the query string and fragment.
export const pagePath = (url: string): string => url.split(/[?#]/)[0];
